export var ReceiptItemStatus;
(function (ReceiptItemStatus) {
    ReceiptItemStatus[ReceiptItemStatus["ENTERED"] = 1] = "ENTERED";
    ReceiptItemStatus[ReceiptItemStatus["PARTIAL"] = 2] = "PARTIAL";
    ReceiptItemStatus[ReceiptItemStatus["FULFILLED"] = 3] = "FULFILLED";
    ReceiptItemStatus[ReceiptItemStatus["VOID"] = 4] = "VOID";
})(ReceiptItemStatus || (ReceiptItemStatus = {}));
//# sourceMappingURL=receipt-item-status.js.map